export default "__VITE_ASSET__CnZDVk3h__"